import { z } from 'zod';
import { ScanProfileTierSchema } from './external-network.schema';
import { ScanProfileSettingsSchema } from './scan-profile-settings.schema';

export const ScanProfileEntitySchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  name: z.string(),
  isSystem: z.boolean(),
  systemTier: ScanProfileTierSchema.nullable().optional(),
  settings: ScanProfileSettingsSchema,
  createdBy: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const CreateScanProfileSchema = z.object({
  name: z.string().min(1).max(100),
  settings: ScanProfileSettingsSchema,
});

export const UpdateScanProfileSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  settings: ScanProfileSettingsSchema,
});

export const AssignExternalNetworkScanProfileSchema = z.object({
  scanProfileId: z.string().min(1),
});

export const ScanProfilePathParamsSchema = z.object({
  scanProfileId: z.string().min(1),
});

export type ScanProfileEntity = z.infer<typeof ScanProfileEntitySchema>;
export type CreateScanProfile = z.infer<typeof CreateScanProfileSchema>;
export type UpdateScanProfile = z.infer<typeof UpdateScanProfileSchema>;
export type AssignExternalNetworkScanProfile = z.infer<
  typeof AssignExternalNetworkScanProfileSchema
>;
